import React from 'react'

import { ConfirmationModal, ModalActionTypes } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'

import { useCashOwedContext } from '../../../providers/CashOwed'

const CashOwedModal = () => {
  const { getRemoteString, StyledRemoteString } = useRemoteStrings()

  const { isCashOwedModalOpen, setIsCashOwedModalOpen } = useCashOwedContext()

  const closeModal = () => setIsCashOwedModalOpen(false)

  return (
    <ConfirmationModal
      actions={[
        {
          handler: closeModal,
          label: 'Got it',
          type: ModalActionTypes.primary,
        },
      ]}
      isOpen={isCashOwedModalOpen}
      onRequestClose={closeModal}
      title={getRemoteString({
        key: 'invest.cash_owed.title',
      })}
      message={
        <StyledRemoteString
          stringKey="invest.cash_owed.description.variable.markdown"
          nodes={[
            <a
              key={0}
              href="https://support.acorns.com/hc/en-us/articles/12184187628563-What-is-Cash-Owed"
              target="_blank"
              rel="noreferrer"
            >
              FAQ
            </a>,
          ]}
        />
      }
    />
  )
}

export default CashOwedModal
